package com.milta.feature.optimizationquota.presentation

import kotlinx.datetime.Instant
import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

/**
 * MIL-97 — date formatting of the quota screens (mobile + web): "JJ/MM" for the reset date shown
 * next to the buttons, "JJ/MM/AAAA" on the counter cards, "JJ/MM · HH:MM" for history rows. The API
 * sends ISO instants; a plain "yyyy-MM-dd" is accepted too.
 */
object OptimizationQuotaFormat {

    fun dayMonth(iso: String?): String = local(iso)?.let { "${pad(it.dayOfMonth)}/${pad(it.monthNumber)}" }.orEmpty()

    fun fullDate(iso: String?): String =
        local(iso)?.let { "${pad(it.dayOfMonth)}/${pad(it.monthNumber)}/${it.year}" }.orEmpty()

    fun dayMonthTime(iso: String?): String =
        local(iso)?.let { "${pad(it.dayOfMonth)}/${pad(it.monthNumber)} · ${pad(it.hour)}:${pad(it.minute)}" }.orEmpty()

    /** "%1 / %2" — remaining over limit, never a percentage (R10). */
    fun ratio(remaining: Int, limit: Int): String = "$remaining / $limit"

    private fun local(iso: String?): LocalDateTime? {
        if (iso.isNullOrBlank()) return null
        runCatching { return Instant.parse(iso).toLocalDateTime(TimeZone.currentSystemDefault()) }
        return runCatching { LocalDate.parse(iso.take(DATE_LENGTH)) }.getOrNull()?.let { LocalDateTime(it.year, it.monthNumber, it.dayOfMonth, 0, 0) }
    }

    private fun pad(n: Int) = n.toString().padStart(2, '0')

    private const val DATE_LENGTH = 10
}
